module.exports = __webpack_public_path__ + "static/media/facebook-share.681effc5.jpg";